import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/logistics")({
  component: LogisticsLayout,
});

function LogisticsLayout() {
  return <Outlet />;
}
